import React from "react";
import axios from "axios";
import Config from "../config";
import { useCommonStore } from "@/store/useCommonStore";

//axios.defaults.validateStatus = (status) => status < 500;

/**
 * 构建 Form 数据请求
 */
function prepareForForm(data) {
    let newBody = '';
    for (let k in data) {
        let v = data[k];
        newBody += `${k}=${v}&`;
    }
    return newBody;
}

/**
* 检查请求回应数据包，判断如果是未认证，跳转到登录地址
*
* @param  {object} response   请求包对象
*
* @return {object|undefined} 返回响应包或者抛出异常
*/
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    if (response.status == 400) {
        return response;
    }
    if (response.status == 401) {
        localStorage.removeItem("user");
        window.location.href = Config.RoutePrefix + '/login';
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}

const dealOption = (method, contentType, data, appid) => {
    let headers;
    let body;
    const state = useCommonStore.getState();
    const auth = state?.user?.auth;
    if (auth) headers = { ...headers, "Authorization": auth.name,"wsctoken": auth.token };
    //headers = {...headers,mode: 'no-cors'};
    //if (appid) headers = { ...headers, "dapr-app-id": appid }
    switch (contentType) {
        case "form":
            headers = { ...headers, "Content-Type": 'application/x-www-form-urlencoded' };
            //headers.Content-Type = 'application/x-www-form-urlencoded';
            body = prepareForForm(data);
            break;
        case "json":
            headers = { ...headers, "Content-Type": 'application/json' };
            //headers.Content-Type = 'application/json';
            body = data;
            break;
        default:
            headers = { ...headers, "Content-Type": 'application/json' };
            //headers.Content-Type = 'application/json';
            body = JSON.stringify(data)
            break;
    }
    return {
        method: method,
        data: body,
        headers: headers,
        //credentials: 'same-origin'
    };
}

export const request = (url, method, contentType, data, appid) => {
    const options = dealOption(method, contentType, data, appid);
    const turls = (url.indexOf("http") > -1) ? url : Config.ApiHost + url;
    return axios(turls, options)
        .then(checkStatus, (reson) => {
            let b = 0;
        })
        .then(resp => {
                return resp.data;
            }
        );
};

export default () => ({ request } );